import { DetailedBenefit } from '../../../../lib/schema/dealer/types';

export const defaultDetailedBenefits: DetailedBenefit[] = [
  {
    title: 'Wide Selection of Vehicles',
    body: 'Explore an extensive inventory of new and pre-owned vehicles to find the perfect match for your needs and budget. Our diverse selection ensures you have access to the latest models and quality used cars, all in one place.',
  },

  {
    title: 'Flexible Financing Options',
    body: 'Benefit from a range of financing solutions tailored to your financial situation. Our finance experts work with multiple lenders to secure competitive rates, making your car-buying experience smooth and affordable.',
  },

  {
    title: 'Comprehensive Service and Parts',
    body: 'Keep your vehicle running smoothly with our full-service maintenance and repair facilities. From routine checks to genuine parts replacement, our certified technicians are here to ensure your EV remains in top condition.',
  },
];

export const benefitOptions = [
  '24/7 Towing',
  'After Sales Support',
  'Concierge Service',
  'Competitive prices',
  'Customization Services',
  'EV Experts',
  'Flexible Financing Options',
  'Home Delivery for Vehicles',
  'Loaner Vehicles',
  'Longer Test Drives',
  'Maintenance Plans',
  'Multiple Charging Stations On-Site',
  'No Haggle Price',
  'On-Site Charging Stations',
  'Online Purchase and Paperwork',
  'Point Of Sale EV Tax Credit',
  'Price Match Guarantee',
  'Service Center',
  'Test Drive at Home',
  'Transparent Trade-In Process',
  'VIP Loyalty Program',
] as const;

type BenefitOption = (typeof benefitOptions)[number];

export const defaultBenefits: BenefitOption[] = [
  'EV Experts',
  'Flexible Financing Options',
  'Competitive prices',
  'Transparent Trade-In Process',
];
